/**
 * InputBar.jsx
 * Text input + send button at the bottom of the chat.
 * Supports Enter to send, Shift+Enter for newline.
 */

import React, { useRef, useEffect } from "react";
import "../ChatPage.css";

export default function InputBar({ onSend, disabled }) {
  const textareaRef = useRef(null);

  // Auto-resize textarea as user types
  useEffect(() => {
    const el = textareaRef.current;
    if (!el) return;
    el.style.height = "auto";
    el.style.height = Math.min(el.scrollHeight, 140) + "px";
  });

  function handleKeyDown(e) {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      submit();
    }
  }

  function submit() {
    const val = textareaRef.current?.value?.trim();
    if (!val || disabled) return;
    onSend(val);
    textareaRef.current.value = "";
    textareaRef.current.style.height = "auto";
  }

  return (
    <div className="hn-input-bar">
      <div className="hn-input-inner">
        <textarea
          ref={textareaRef}
          className="hn-textarea"
          placeholder="Ask about candidates, jobs, interviews..."
          rows={1}
          onKeyDown={handleKeyDown}
          disabled={disabled}
        />
        <button
          className={`hn-send-btn ${disabled ? "hn-send-disabled" : ""}`}
          onClick={submit}
          disabled={disabled}
          title="Send message"
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M5 12h14" />
            <path d="m12 5 7 7-7 7" />
          </svg>
        </button>
      </div>
      <p className="hn-input-hint">
        <span>Press</span> <kbd>Enter</kbd> <span>to send</span> · <kbd>Shift+Enter</kbd> <span>for new line</span>
      </p>
    </div>
  );
}
